"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireDefault(require("../../Button/Button"));
var _BasicInputRow = _interopRequireDefault(require("../../Form/BasicInputRow"));
var _constants = require("../../constants");
var _MediaContext = require("../../MediaContext/MediaContext");
var Signup = function Signup(_ref) {
  var title = _ref.title,
    text = _ref.text,
    toggle = _ref.toggle,
    noCloseIcon = _ref.noCloseIcon,
    image = _ref.image,
    addressBookId = _ref.addressBookId,
    mobileLink = _ref.mobileLink,
    subscribeButtonText = _ref.subscribeButtonText,
    successMessage = _ref.successMessage,
    companyId = _ref.companyId;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-u-component-padding"
  }, !noCloseIcon && /*#__PURE__*/_react["default"].createElement(_MediaContext.Media, {
    greaterThanOrEqual: _constants.BREAKPOINTS.MD
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal--close-desktop"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    icon: "cross",
    buttonType: _constants.BUTTON_TYPES.BARE,
    onClick: toggle,
    buttonSize: _constants.BUTTON_SIZES.LARGE
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid grid-gap-md"
  }, image && /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(!mobileLink && 'display@md', " col-5@md d8-u-bg-img d8-u-radius-md"),
    style: {
      backgroundImage: "url(".concat(image.url, ")")
    },
    "aria-label": image.alt
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-7@md text-center d8-u-component-padding"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-center text-left@xs"
  }, title && /*#__PURE__*/_react["default"].createElement("h3", {
    className: "d8-u-ls-sm d8-u-color-primary text-md margin-bottom-md"
  }, title), text && /*#__PURE__*/_react["default"].createElement("p", null, text)), /*#__PURE__*/_react["default"].createElement(_MediaContext.Media, {
    lessThan: _constants.BREAKPOINTS.MD
  }, mobileLink && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    className: "margin-top-md",
    link: mobileLink,
    text: "Sign up"
  }), !mobileLink && /*#__PURE__*/_react["default"].createElement("div", {
    className: "margin-top-md"
  }, /*#__PURE__*/_react["default"].createElement(_BasicInputRow["default"], {
    postTo: "/api/marketing/add-contact",
    extraBodyProps: {
      addressBookId: addressBookId,
      companyId: companyId
    },
    successMessage: successMessage,
    subscribeButtonText: subscribeButtonText,
    fullWidth: true
  }))), /*#__PURE__*/_react["default"].createElement(_MediaContext.Media, {
    greaterThanOrEqual: _constants.BREAKPOINTS.MD
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "margin-top-md"
  }, /*#__PURE__*/_react["default"].createElement(_BasicInputRow["default"], {
    postTo: "/api/marketing/add-contact",
    extraBodyProps: {
      addressBookId: addressBookId,
      companyId: companyId
    },
    successMessage: successMessage,
    subscribeButtonText: subscribeButtonText,
    fullWidth: true
  }))))), !noCloseIcon && /*#__PURE__*/_react["default"].createElement(_MediaContext.Media, {
    lessThan: _constants.BREAKPOINTS.MD
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-center text-center"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    text: "Close",
    buttonType: _constants.BUTTON_TYPES.BARE,
    onClick: toggle
  }))));
};
Signup.propTypes = {
  title: _propTypes["default"].string,
  text: _propTypes["default"].string,
  toggle: _propTypes["default"].func,
  image: _propTypes["default"].object,
  noCloseIcon: _propTypes["default"].bool,
  addressBookId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
  mobileLink: _propTypes["default"].string,
  subscribeButtonText: _propTypes["default"].string,
  successMessage: _propTypes["default"].string,
  companyId: _propTypes["default"].number
};
Signup.defaultProps = {
  subscribeButtonText: 'Subscribe',
  successMessage: 'You\'re signed up!'
};
var _default = exports["default"] = Signup;